import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  // On app load: check localStorage
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const storedToken = localStorage.getItem("token");
    const storedExpiry = localStorage.getItem("tokenExpiry");

    if (storedUser && storedToken && storedExpiry) {
      const isExpired = Date.now() > parseInt(storedExpiry);
      if (!isExpired) {
        setUser(storedUser);
        setToken(storedToken);
      } else {
        logout(); // auto logout on expired token
      }
    }
  }, []);

  // Auto logout timer
  useEffect(() => {
    const expiry = localStorage.getItem("tokenExpiry");
    if (token && expiry) {
      const timeout = parseInt(expiry) - Date.now();
      if (timeout > 0) {
        const timer = setTimeout(() => logout(), timeout);
        return () => clearTimeout(timer);
      } else {
        logout();
      }
    }
  }, [token]);

  // Login method
  const login = ({ user, token, expiresIn }) => {
    const expiryTime = Date.now() + expiresIn * 1000;

    setUser(user);
    setToken(token);

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", token);
    localStorage.setItem("tokenExpiry", expiryTime.toString());
  };

  // Logout method
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// useAuth hook to consume context
export const useAuth = () => useContext(AuthContext);
